import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

const mediaDetail = (id) => (
	fetch(`${apiUri}/report/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default mediaDetail;



// WEBPACK FOOTER //
// ./src/js/request/mediaDetail.js